import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=7ac0f119"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports